import { Button } from '@mm/components';
import { useSelector } from 'react-redux';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React, { ReactNode } from 'react';
import styles from './BaseIntegration.module.css';

export type BaseIntegrationEmptyStateProps = {
  icon: ReactNode;
  button: string | ReactNode;
  onClick?: () => void;
  text?: string;
  featureFlag?: string;
  landmineName: string;
};

export const BaseIntegrationEmptyState = ({
  icon,
  button,
  onClick,
  text,
  featureFlag,
  landmineName,
}: BaseIntegrationEmptyStateProps) => {
  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  const hasFeatureFlag = featureFlag ? !!featureFlags[featureFlag] : true;
  const { openNewBillingModal2023 } = useModalActions();

  const showUpgradeModal = () => {
    openNewBillingModal2023({
      landmineName,
    });
  };

  const onButtonClick = e => {
    if (!hasFeatureFlag) {
      e.stopPropagation();
      showUpgradeModal();
    } else {
      onClick?.();
    }
  };

  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.emptyStateBody}>
        {icon}
        <div className={styles.emptyStateActionContainer}>
          {text && <div className={styles.text}>{text}</div>}
          {typeof button === 'string' ? (
            <Button
              onClick={onButtonClick}
              css={{ container: 'integrations__empty-state-button' }}
            >
              {button}
            </Button>
          ) : (
            button
          )}
        </div>
      </div>
    </div>
  );
};
